import { render, staticRenderFns } from "./Original.vue?vue&type=template&id=70531288&scoped=true&"
import script from "./Original.vue?vue&type=script&lang=js&"
export * from "./Original.vue?vue&type=script&lang=js&"
import style0 from "./Original.vue?vue&type=style&index=0&id=70531288&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70531288",
  null
  
)

export default component.exports